import React, { type ReactElement, type ReactNode } from 'react'
import { Outlet } from 'react-router-dom'

import styles from './AuthLayout.module.scss'

interface AuthLayoutProps {
  children?: ReactNode
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children }): ReactElement => {
  return (
    <div className={styles.container}>
      <Outlet />
    </div>
  )
}

export default AuthLayout
